import { MuiThemeProvider } from '@material-ui/core/styles';
import * as mdColors from '@material-ui/core/colors';
import { createMuiTheme } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';

import React, { Component } from 'react';
import { BrowserRouter, Route, Redirect, Switch } from 'react-router-dom';
import './App.css';

import Banner from './Banner';
import Login from './Login';
import Recover from './Recover';
import RecoverComplete from './RecoverComplete';
import ForgotPassword from './ForgotPassword';
import ForgotPasswordComplete from './ForgotPasswordComplete';
import Register from './Register';
import RegisterComplete from './RegisterComplete';
import Footer from './Footer';

import { Helmet } from "react-helmet";
import MenuLinks from "./MenuLinks/MenuLinks";

class App extends Component {
  constructor(props) {
    super(props);

    let accentColor = mdColors.amber[300];

    if (props.appTheme.accentColor) {
        accentColor = props.appTheme.accentColor;
    }

      console.log(accentColor, mdColors);
    this.state = { allowCreate: true };
    this.theme = createMuiTheme({
      palette: {
        primary: mdColors.blue,
        secondary: { main: accentColor, },
      },
    });
    this.onLogin = (data, username) => {
      window.location.href = this.props.returnUrl;
      if (props.isCordova) {
        localStorage.setItem('last_username', username);
      }
    };
  }
  render() {
    return (
      <BrowserRouter>
        <MuiThemeProvider
          theme={this.theme}>
          <Grid
            container
            spacing={0}
            className="App">
            <Helmet>
              <title>{this.props.title || 'Login page'}</title>
              <link rel="shortcut icon" href={this.props.favicon} />
          </Helmet>
            <Hidden xsDown>
              <Grid
                sm
                item>
                <Banner
                  appTheme={this.props.appTheme}></Banner>
              </Grid>
            </Hidden>
            <Grid
              className="Sidenav"
              xs={12}
              sm={3}
              item>
              {this.props.appTheme.mobileLogoPath && <Hidden smUp>
                <img
                  src={this.props.appTheme.mobileLogoPath}
                  className="company-logo"
                  alt="" />
              </Hidden>}
              {this.props.appTheme.loginMenu && <div><MenuLinks menu={this.props.appTheme.loginMenu}></MenuLinks></div>}
              <Switch>
                <Route
                  path="/"
                  exact
                  render={(props) => <Login
                    allowCreate={this.state.allowCreate}
                    onLogin={this.onLogin}
                    facebookAppId={this.props.facebookAppId}
                    googleAppId={this.props.googleAppId}
                    {...props} {...this.props}/> } />
                <Route
                  exact
                  path="/register"
                  render={(props) => this.state.allowCreate ?
                    <Register
                      text={this.props.appTheme.registerText}
                      instanceName={this.props.title}
                      termsShort={this.props.termsShort}
                      termsLong={this.props.termsLong}
                      captchaKey={this.props.captchaKey}
                      {...props} /> :
                    <Redirect to="/" /> } />
                <Route
                  exact
                  path="/recover"
                  render={(props) => ( <Recover text={this.props.appTheme.recoverText} errorText={this.props.appTheme.recoverErrorText} {...props} /> )} />
                <Route
                  exact
                  path="/recoverComplete"
                  render={(props) => ( <RecoverComplete text={this.props.appTheme.recoverCompleteText} {...props} /> )} />
                <Route
                  exact
                  path="/forgotPassword/"
                  render={(props) => ( <ForgotPassword
                    invalidTokenText={this.props.appTheme.forgotPasswordInvalidTokenText}
                    {...props} /> )} />
                <Route
                  exact
                  path="/forgotPasswordComplete"
                  render={(props) => ( <ForgotPasswordComplete
                    text={this.props.appTheme.forgotPasswordCompleteText}
                    {...props} /> )} />
                { /* allow welcome screen only after a successful registration */ }
                <Route
                  exact
                  path="/welcome"
                  render={(props) => this.state.allowCreate ?
                    <RegisterComplete
                      onComplete={this.onLogin}
                      text={this.props.appTheme.registerCompleteText}
                      linkHeader={this.props.appTheme.instanceURLHeader}
                      instanceUrl={this.props.instanceUrl}
                      showStart={this.props.instanceUrl !== this.props.returnUrl}
                      {...props} /> :
                    <Redirect to="/" /> } />
                { /* fallback to login page */ }
                <Redirect to="/" />
              </Switch>
              <Footer
                appTheme={this.props.appTheme}></Footer>
            </Grid>
          </Grid>
        </MuiThemeProvider>
      </BrowserRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js